
import { getStayRoomListAll, reserveStayRoom } from '@/api/stayRoom';
import { parseConcatNumber } from '@/utils/filters';
import { ElForm } from 'element-ui/types/form';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class extends Vue {
  mounted() {
    this.getRoomList();
  }

  private form: any = {
    name: '',
    roomIdx: null,
    adult: 2,
    child: 0,
    phone: '',
    useDate: '',
    endDate: '',
    dateRange: [],
    businessMemo: '',
  }

  private roomList: any = [];

  private loading = false;

  private validatePhone = (rule:any, value:any, callback:any) => {
    const reqPhone = /^[0-9]{3}-[0-9]{3,4}-[0-9]{4}$/;
    if (!reqPhone.test(value)) {
      callback(new Error('연락처 형식에 맞지 않습니다.'));
    } else {
      callback();
    }
  };

  private rules = {
    name: [
      { required: true, message: '예약자명을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    roomIdx: [
      { required: true, message: '객실을 선택하세요.', trigger: ['change', 'blur'] },
    ],
    dateRange: [
      { required: true, message: '체크인/아웃을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    adult: [
      { required: true, message: '인원을 입력하세요.', trigger: ['blur', 'change'] },
    ],
    phone: [
      { required: true, message: '연락처를 입력하세요.', trigger: ['change', 'blur'] },
      { validator: this.validatePhone, trigger: ['change', 'blur'] },
    ],
  }

  private getRoomList() {
    this.loading = true;
    getStayRoomListAll().then((res) => {
      this.loading = false;
      this.roomList = res.data;
    });
  }

  private filterPhone() {
    this.form.phone = parseConcatNumber(this.form.phone);
  }

  private handleClickSave() {
    (this.$refs.reserveForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.$confirm('정말 신규 예약을 등록 하시겠습니까?', '신규 예약', {
          confirmButtonText: '등록',
          cancelButtonText: '취소',
          type: 'info',
        }).then(() => {
          this.loading = true;
          reserveStayRoom(this.form).then(() => {
            this.loading = false;
            this.$message.success('신규 예약이 등록되었습니다.');
            this.form = {
              name: '',
              roomIdx: null,
              adult: 2,
              child: 0,
              phone: '',
              useDate: '',
              endDate: '',
              dateRange: [],
              businessMemo: '',
            };
          });
        });
      }
    });
  }

  /* eslint-disable */
  private handleChangeDateRange() {
    if (this.form.dateRange && this.form.dateRange.length === 2) {
      this.form.useDate = this.form.dateRange[0];
      this.form.endDate = this.form.dateRange[1];
    } else {
      this.form.useDate = '';
      this.form.endDate = '';
    }
  }
  /* eslint-enable */
}
